import { render, staticRenderFns } from "./ReplyEmailHead.vue?vue&type=template&id=5edd2256&scoped=true&"
import script from "./ReplyEmailHead.vue?vue&type=script&lang=js&"
export * from "./ReplyEmailHead.vue?vue&type=script&lang=js&"
import style0 from "./ReplyEmailHead.vue?vue&type=style&index=0&id=5edd2256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd2256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edd2256')) {
      api.createRecord('5edd2256', component.options)
    } else {
      api.reload('5edd2256', component.options)
    }
    module.hot.accept("./ReplyEmailHead.vue?vue&type=template&id=5edd2256&scoped=true&", function () {
      api.rerender('5edd2256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/ReplyEmailHead.vue"
export default component.exports